import React, { useState, useRef, useEffect } from "react";
import useOnclickOutside from "react-cool-onclickoutside";
import Checkbox from "@material-ui/core/Checkbox";

import "./Dropdown.styles.scss";
import toggle_down from "./assets/toggle_down.svg";
import { ReactComponent as SearchIcon } from "./assets/search_icon.svg";

//Dependencies
//npm add node-sass
//npm add react-cool-onclickoutside
//npm add @material-ui/core

const Dropdown = ({
  title,
  items,
  multiselect = false,
  onChange,
  spots,
  fse,
  reset,
  searchable,
}) => {
  const [open, setOpen] = useState(false);
  const [selection, setSelection] = useState([]);
  const [search, setSearch] = useState("");
  const toggle = () => setOpen(!open);
  const [checked, setChecked] = useState(true);
  const ref = useRef();

  useEffect(() => {
    if (reset) setSelection([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);

  const handleChange = (event) => {
    console.log(checked);
    setChecked(event.target.checked);
  };
  useOnclickOutside(ref, () => {
    if (open === true) setOpen(false);
  });

  const filteredItems = items.filter((item) => {
    return item.name.toLowerCase().includes(search.toLocaleLowerCase());
  });

  const handleOnClick = (item) => {
    if (!selection.some((current) => current.id === item.id)) {
      if (!multiselect) {
        setSelection([item]);
        onChange(item);
      } else if (multiselect) {
        setSelection([...selection, item]);
        onChange([...selection, item]);
      }
    } else {
      let selectionAfterRemoval = selection;
      selectionAfterRemoval = selectionAfterRemoval.filter(
        (current) => current.id !== item.id
      );
      setSelection([...selectionAfterRemoval]);
      onChange([...selectionAfterRemoval]);
    }
  };

  const isItemInSelection = (item) => {
    if (selection.find((current) => current.id === item.id)) {
      return true;
    }
    return false;
  };

  return (
    <div className="create-mdo-select ignore-onclickoutside">
      <div className="dd-wrapper">
        <div
          tabIndex={0}
          className="dd-header"
          role="button"
          onKeyPress={() => toggle(!open)}
          onClick={() => toggle(!open)}
        >
          <div className="dd-header__title">
            {selection.length > 0 && (
              <p
                className="header-title-absolute"
                style={{ margin: 0, opacity: 0.6 }}
              >
                {title}
              </p>
            )}
            {multiselect ? (
              <div className="dd-header__filter--box">
                {selection.length === 0 && (
                  <p className="dd-header__title--grey">{title}</p>
                )}
                {selection.length !== 0 &&
                  selection.length === items.length && (
                    <p className="dd-header__title--filter--active">
                      All Spots Selected
                    </p>
                  )}
                {selection.length > 0 &&
                  selection.length < 8 &&
                  selection.map((spot, index) => (
                    <p
                      key={spot.id}
                      className="dd-header__title--filter--active"
                    >
                      {spot.name}
                      {index === selection.length - 1 ? `` : `, `}&nbsp;
                    </p>
                  ))}

                {selection.length > 7 && (
                  <p className="dd-header__title--filter--active">
                    {selection[0].name}, {selection[1].name},{" "}
                    {selection[2].name}, {selection[3].name},{" "}
                    {selection[4].name}, {selection[5].name},{" "}
                    {selection[6].name}...
                    {selection.length - 7} more
                  </p>
                )}
              </div>
            ) : (
              <p
                className={
                  selection.length > 0
                    ? `dd-header__title--black`
                    : `dd-header__title--grey`
                }
              >
                {selection.length > 0 ? `${selection[0].name}` : `${title}`}
              </p>
            )}
          </div>
          <div className="dd-header__action--openclose">
            {open ? (
              <img className="close" src={toggle_down} alt="close" />
            ) : (
              <img src={toggle_down} alt="open" />
            )}
          </div>
        </div>
        {open && (
          <div className="dd-list-container" ref={ref}>
            {
              <div className="dd-searchbox">
                <label className="search-lable" htmlFor="search_input">
                  <SearchIcon
                    className="search-icon"
                    aria-hidden="true"
                    alt="Search"
                  />
                </label>

                <input
                  type="text"
                  name="search"
                  id="search_input"
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            }

            {spots && items.length > 0 && (
              <div
                className="dd-action--select-all"
                onClick={() => {
                  setSelection([...items]);
                  onChange(items);
                }}
              >
                <p>Select All</p>
              </div>
            )}

            <ul className="dd-list-content">
              {spots && items.length < 1 && (
                <li className="dd-list-item">
                  Please Select an FSE to see all spots
                </li>
              )}
              {fse && items.length < 1 && (
                <li className="dd-list-item">
                  Please Select an Agency to see all FSEs.
                </li>
              )}
              {items.length > 1 && filteredItems.length === 0 && (
                <li className="dd-list-item">Search found no results</li>
              )}
              {filteredItems.map((item) => (
                <li
                  className="dd-list-item"
                  key={item.id ? item.id : item.name}
                >
                  {multiselect ? (
                    <button
                      className="padding-m"
                      type="button"
                      onClick={() => handleOnClick(item)}
                    >
                      <Checkbox
                        className="checkbox"
                        checked={isItemInSelection(item)}
                        onChange={handleChange}
                        inputProps={{ "aria-label": "primary checkbox" }}
                      />

                      <span className="name l-padding">{item.name}</span>
                    </button>
                  ) : (
                    <button
                      className="padding-s"
                      type="button"
                      onClick={() => {
                        handleOnClick(item);
                        setOpen(!open);
                      }}
                    >
                      <span className="name">{item.name}</span>
                    </button>
                  )}
                </li>
              ))}
            </ul>

            <div
              className="dd-action--clear"
              onClick={() => {
                setSelection([]);
                onChange([]);
              }}
            >
              {selection.length > 0 && <p>Clear Filter</p>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
